<template>
  <aside class="debug-component">
    <ul class="debug--store">
      <li class="debug-item">
        <button @click="clearLocalStorage">
        Clear Local Storage
        </button>
        <button @click="toggleLoading">Toggle loading</button>
      </li>
      <li class="debug-item" v-if="$i18n.locale">
        <span class="debug-item__header">Locale</span>
        <span class="debug-item__value">{{ $i18n.locale }}</span>
      </li>
      <li class="debug-item" v-if="cart.cartGuid">
        <span class="debug-item__header">CartGuid</span>
        <span class="debug-item__value">{{ cart.cartGuid }}</span>
      </li>
      <li class="debug-item" v-if="cart.cartExpiryTime">
        <span class="debug-item__header">Cart Expiry Time</span>
        <span class="debug-item__value">{{ cart.cartExpiryTime }}</span>
      </li>
      <li class="debug-item">
        <span class="debug-item__header">Loading</span>
        <span class="debug-item__value">{{ loading }}</span>
      </li>
      <li class="debug-item" v-if="performance.mode != ''">
        <span class="debug-item__header">Mode</span>
        <span class="debug-item__value">{{ performance.mode }}</span>
      </li>
      <li class="debug-item">
        <span class="debug-item__header">Route</span>
        <span class="debug-item__value">Route: {{ $route.name }} <br> Stage: {{ stage }}</span>
      </li>
      <li class="debug-item" v-if="event.title">
        <span class="debug-item__header">Event/Session Title</span>
        <span class="debug-item__value">{{ event.title }}</span>
      </li>
      <li class="debug-item" v-if="event.icAttributesList.length > 0">
        <span class="debug-item__header">icAttributesList</span>
        <span class="debug-item__value">{{ event.icAttributesList }}</span>
      </li>
      <li class="debug-item" v-if="error.length > 0">
        <span class="debug-item__header">error</span>
        <span class="debug-item__value">{{ error }}</span>
      </li>
      <li class="debug-item" v-if="cart.inventoryIdsReservedList > 0">
        <span class="debug-item__header">Seats Reserved List</span>
        <span class="debug-item__value">{{ cart.inventoryIdsReservedList }}</span>
      </li>
      <li class="debug-item" v-if="performance.productId != -1">
        <span class="debug-item__header">Product Id</span>
        <span class="debug-item__value">{{ performance.productId }}</span>
      </li>
      <li class="debug-item" v-if="cart.numberOfItemsInCart > 0">
        <span class="debug-item__header">numberOfItemsInCart</span>
        <span class="debug-item__value">{{ cart.numberOfItemsInCart }}</span>
      </li>
    </ul>
  </aside>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: "debug",
  methods: {
    toggleLoading() {
      this.updateLoading(!this.loading)
    },
    closeDebug() {
      this.updateDebug(false);
    },
    async clearLocalStorage() {
      await this.destroyCartInstance("debug");
      localStorage.clear();

      if(this.stage == "choose-date-time") { 
        location.reload()
      } else if(this.$route.name.includes("registration")) {
        this.$router.push({ name: "registration-flow", params: { locale: this.$i18n.locale, event: this.$route.params.icc } });
      } else if(this.$route.name != "choose-seat-flow") {
        this.$router.push({ name: "choose-seat-flow", params: { locale: this.$i18n.locale, icc: this.$route.params.icc } });
      }

      this.updateStage("choose-date-time")
    },
    ...mapActions(['updateLoading', 'updateDebug', 'destroyCartInstance', 'updateStage'])
  },
  computed: {
    /*
     * Below this point is currently for debugging purposes
     * However, some of these computed properties may want to be retained long-term
     */
    ...mapState(['loading', 'error', 'cart', 'performance', 'packageAPI', 'event', 'stage', 'user'])
  },
};
</script>
